var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    scopedSlots: _vm._u([{
      key: "subHead",
      fn: function fn() {
        return [_c('sub-visual', {
          attrs: {
            "id": "irrigation",
            "title": "Solution",
            "src": "/images/sub/subvisual-solution.jpg"
          }
        })];
      },
      proxy: true
    }])
  }, [_c('page-section', {
    staticClass: "page-section--first",
    scopedSlots: _vm._u([{
      key: "titleLine",
      fn: function fn() {
        return [_vm._v(" Smart Farm Solution ")];
      },
      proxy: true
    }])
  }, [_c('tit-wrap-large', {
    scopedSlots: _vm._u([{
      key: "text",
      fn: function fn() {
        return [_vm._v("The system saves water by diagnosing the current state of the field and supplying the proper amount of water as much as needed. "), _c('br', {
          staticClass: "d-none d-lg-block"
        }), _vm._v("It also promotes crop growth through optimized smart irrigation control based on time, flow rate, water content deviations, etc.")];
      },
      proxy: true
    }])
  }, [_vm._v(" A system that facilitates field management "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _c('b', [_vm._v("Integrated Smart Irrigation Control System")])]), _c('v-img', {
    staticClass: "mx-auto",
    attrs: {
      "max-width": "528",
      "aspect-ratio": 528 / 786,
      "src": "/images/sub/solution/smartfarm/irrigation-img.png",
      "data-aos": "fade",
      "data-aos-delay": "100"
    }
  })], 1), _c('v-container', [_c('v-divider', {
    staticClass: "grey lighten-3"
  })], 1), _c('page-section', [_c('page-section', {
    staticClass: "page-section--sm py-0",
    scopedSlots: _vm._u([{
      key: "pageSectionImmersive",
      fn: function fn() {
        return [_c('v-row', {
          staticClass: "mx-n20px my-n10px mx-md-n30px my-md-n20px"
        }, [_c('v-col', {
          staticClass: "px-20px py-10px px-md-30px py-md-20px",
          attrs: {
            "cols": "12",
            "md": "6",
            "data-aos": "fade-left",
            "data-aos-delay": "200"
          }
        }, [_c('v-card', {
          attrs: {
            "outlined": "",
            "rounded": ""
          }
        }, [_c('v-responsive', {
          attrs: {
            "aspect-ratio": 570 / 456,
            "content-class": "d-flex pa-20px"
          }
        }, [_c('v-img', {
          staticClass: "ma-auto",
          attrs: {
            "max-width": "242",
            "aspect-ratio": 242 / 348,
            "src": "/images/sub/solution/smartfarm/irrigation-img2.png"
          }
        })], 1)], 1)], 1), _c('v-col', {
          staticClass: "px-20px py-10px px-md-30px py-md-20px",
          attrs: {
            "cols": "12",
            "md": "6",
            "data-aos": "fade-right",
            "data-aos-delay": "200"
          }
        }, [_c('div', {
          staticClass: "mt-md-24px"
        }, [_c('tit-wrap-sprout', [_vm._v(" Smart water control system ")]), _c('txt-item', {
          attrs: {
            "titleClass": "w-md-140px"
          },
          scopedSlots: _vm._u([{
            key: "title",
            fn: function fn() {
              return [_vm._v("Control items")];
            },
            proxy: true
          }])
        }, [_vm._v(" Time, amount of light, and weight "), _c('div', {
          staticClass: "font-size-16 font-size-md-18"
        }, [_vm._v("*Weight control-based nutrient solution management algorithm")])]), _c('txt-item', {
          attrs: {
            "titleClass": "w-md-140px"
          },
          scopedSlots: _vm._u([{
            key: "title",
            fn: function fn() {
              return [_vm._v("Irrigation types")];
            },
            proxy: true
          }])
        }, [_vm._v(" Time-based irrigation, flow rate-based irrigation, and water content-based irrigation ")]), _c('txt-item', {
          attrs: {
            "titleClass": "w-md-140px"
          },
          scopedSlots: _vm._u([{
            key: "title",
            fn: function fn() {
              return [_vm._v("Settings")];
            },
            proxy: true
          }])
        }, [_vm._v(" Zone settings (up to 10)"), _c('br'), _vm._v("Irrigation intervals by zone"), _c('br'), _vm._v("Irrigation period"), _c('br'), _vm._v("EC and pH settings by zone"), _c('br'), _vm._v("Amount of irrigation in each stock of crop"), _c('br'), _vm._v("Upper and lower limit alarm of EC and pH ")]), _c('txt-item', {
          attrs: {
            "titleClass": "w-md-140px"
          },
          scopedSlots: _vm._u([{
            key: "title",
            fn: function fn() {
              return [_vm._v("Lookup item")];
            },
            proxy: true
          }])
        }, [_vm._v(" Nutrient solution supply machine operation record, root zone monitoring record, and real-time greenhouse environment data, greenhouse environment data by time ")]), _c('txt-item', {
          attrs: {
            "titleClass": "w-md-140px"
          },
          scopedSlots: _vm._u([{
            key: "title",
            fn: function fn() {
              return [_vm._v("Other functions")];
            },
            proxy: true
          }])
        }, [_vm._v(" Manual irrigation for emergency ")])], 1)])], 1)];
      },
      proxy: true
    }])
  }), _c('page-section', {
    staticClass: "page-section--sm pb-0",
    scopedSlots: _vm._u([{
      key: "pageSectionImmersive",
      fn: function fn() {
        return [_c('v-card', {
          attrs: {
            "rounded": "",
            "color": "grey lighten-5",
            "data-aos": "fade",
            "data-aos-delay": "100"
          }
        }, [_c('v-responsive', {
          attrs: {
            "aspect-ratio": 1200 / 770,
            "content-class": "d-flex align-center justify-center"
          }
        }, [_c('div', {
          staticClass: "pa-30px pa-md-40px px-lg-80px"
        }, [_c('v-img', {
          staticClass: "mx-auto",
          attrs: {
            "max-width": "600",
            "width": _vm.$vuetify.breakpoint.lgAndUp ? '600' : '',
            "aspect-ratio": 600 / 376,
            "src": "/images/sub/solution/smartfarm/irrigation-img3.png"
          }
        }), _c('div', {
          staticClass: "pt-30px pt-md-40px pt-lg-60px"
        }, [_c('tit-wrap-small', {
          scopedSlots: _vm._u([{
            key: "text",
            fn: function fn() {
              return [_vm._v("The system helps you set and decide the cultivation environment conditions through a variety of records such as operational data of the nutrient solution supply machine, root zone monitoring data, and greenhouse environment data.")];
            },
            proxy: true
          }])
        }, [_vm._v(" Easy and simple real-time monitoring via the Internet and mobile device ")])], 1)], 1)])], 1)];
      },
      proxy: true
    }])
  }), _c('page-section', {
    staticClass: "page-section--sm pb-0",
    scopedSlots: _vm._u([{
      key: "pageSectionImmersive",
      fn: function fn() {
        return [_c('v-row', {
          attrs: {
            "justify": "center"
          }
        }, [_c('v-col', {
          attrs: {
            "cols": "12",
            "md": "6",
            "lg": "4",
            "data-aos": "fade",
            "data-aos-delay": "100"
          }
        }, [_c('v-card', {
          attrs: {
            "outlined": "",
            "rounded": ""
          }
        }, [_c('v-img', {
          staticClass: "ma-auto",
          attrs: {
            "max-width": "382",
            "aspect-ratio": 382 / 540,
            "src": "/images/sub/solution/smartfarm/irrigation-img4.jpg"
          }
        })], 1), _c('tit-wrap-small', {
          staticClass: "mt-14px mt-md-20px",
          attrs: {
            "mbSmall": ""
          },
          scopedSlots: _vm._u([{
            key: "text",
            fn: function fn() {
              return [_vm._v(" Apparatus for Managing Nutriculture ")];
            },
            proxy: true
          }])
        }, [_vm._v(" Registered Patent ")])], 1)], 1)];
      },
      proxy: true
    }])
  })], 1), _c('page-section', {
    staticClass: "grey lighten-5"
  }, [_c('page-section', {
    staticClass: "page-section--sm py-0"
  }, [_c('tit-wrap-large', {
    staticClass: "tit-wrap--lg"
  }, [_c('b', [_vm._v("All-in-one smart irrigation solution")]), _vm._v(" "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v("that manages the root zone environment")]), _c('v-row', {
    staticClass: "row--lg",
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6",
      "lg": "4",
      "data-aos": "fade-up",
      "data-aos-delay": "100"
    }
  }, [_c('v-card', {
    staticClass: "text-center",
    attrs: {
      "rounded": ""
    }
  }, [_c('v-responsive', {
    attrs: {
      "aspect-ratio": 372 / 210,
      "content-class": "d-flex align-center justify-center"
    }
  }, [_c('div', {
    staticClass: "pa-20px"
  }, [_c('div', [_c('v-img', {
    staticClass: "mx-auto",
    attrs: {
      "max-width": "40",
      "aspect-ratio": 40 / 30,
      "src": "/images/icon/icon-sprout.svg"
    }
  }), _c('div', {
    staticClass: "mt-16px mt-md-24px"
  }, [_c('p', {
    staticClass: "txt txt--lg txt--dark line-height-15"
  }, [_vm._v("Applies an irrigation system based on the water content of root zones")])])], 1)])])], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6",
      "lg": "4",
      "data-aos": "fade-up",
      "data-aos-delay": "200"
    }
  }, [_c('v-card', {
    staticClass: "text-center",
    attrs: {
      "rounded": ""
    }
  }, [_c('v-responsive', {
    attrs: {
      "aspect-ratio": 372 / 210,
      "content-class": "d-flex align-center justify-center"
    }
  }, [_c('div', {
    staticClass: "pa-20px"
  }, [_c('div', [_c('v-img', {
    staticClass: "mx-auto",
    attrs: {
      "max-width": "40",
      "aspect-ratio": 40 / 30,
      "src": "/images/icon/icon-sprout.svg"
    }
  }), _c('div', {
    staticClass: "mt-16px mt-md-24px"
  }, [_c('p', {
    staticClass: "txt txt--lg txt--dark line-height-15"
  }, [_vm._v("Creates irrigation control algorithms through data learning on the root zones")])])], 1)])])], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6",
      "lg": "4",
      "data-aos": "fade-up",
      "data-aos-delay": "300"
    }
  }, [_c('v-card', {
    staticClass: "text-center",
    attrs: {
      "rounded": ""
    }
  }, [_c('v-responsive', {
    attrs: {
      "aspect-ratio": 372 / 210,
      "content-class": "d-flex align-center justify-center"
    }
  }, [_c('div', {
    staticClass: "pa-20px"
  }, [_c('div', [_c('v-img', {
    staticClass: "mx-auto",
    attrs: {
      "max-width": "40",
      "aspect-ratio": 40 / 30,
      "src": "/images/icon/icon-sprout.svg"
    }
  }), _c('div', {
    staticClass: "mt-16px mt-md-24px"
  }, [_c('p', {
    staticClass: "txt txt--lg txt--dark line-height-15"
  }, [_vm._v("Provides an integrated solution through root zone measurement")])])], 1)])])], 1)], 1)], 1)], 1), _c('page-section', {
    staticClass: "page-section--sm pb-0"
  }, [_c('v-img', {
    staticClass: "ma-auto",
    attrs: {
      "max-width": "966",
      "aspect-ratio": 966 / 680,
      "src": "/images/sub/solution/smartfarm/irrigation-img5-en.png",
      "data-aos": "fade",
      "data-aos-delay": "400"
    }
  })], 1)], 1), _c('page-section', {
    staticClass: "page-section--last",
    attrs: {
      "id": "irrigation-portfolio"
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function fn() {
        return [_vm._v(" Portfolio ")];
      },
      proxy: true
    }, {
      key: "pageSectionImmersive",
      fn: function fn() {
        return [_c('div', {
          staticClass: "mx-auto px-12px",
          staticStyle: {
            "max-width": "1480px"
          }
        }, [_c('irrigation-slide')], 1)];
      },
      proxy: true
    }])
  }, [_c('div')])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }